import { Spin } from "antd";
import { useGetBooking } from "~/services/booking";
import { useBooking } from "~/store";
import { cn } from "~/utils";
import { PreviewBookingCard } from "./preview-booking-card";
import { useEffect } from "react";
import { BookingInfoForm } from "./booking-info-form";

export const BookingForm = () => {
  const { bookingId, setBooking } = useBooking();

  const { data: booking, isLoading } = useGetBooking(bookingId);

  useEffect(() => {
    if (!booking) return;

    setBooking(booking);

    return () => {
      setBooking(undefined);
    };
  }, [booking, setBooking]);

  return (
    <Spin spinning={isLoading}>
      <div className={cn("w-full mx-auto")}>
        {/* Header */}
        <BookingInfoForm booking={booking} openAddService={() => {}} />

      
      </div>
    </Spin>
  );
};
